import { frontendURL } from 'dashboard/helper/URLHelper';
import store from 'dashboard/store';

const ensureOnboardingFetched = async accountId => {
  const fetchedAccountId = store.getters['wgptOnboarding/accountId'];
  if (fetchedAccountId === accountId) return;
  await store.dispatch('wgptOnboarding/get', accountId);
};

const onboardingGuard = userAuthentication => (to, _from, next) => {
  const routeAccountId = to.params.accountId;

  const authPromise = routeAccountId
    ? userAuthentication.then(() => ensureOnboardingFetched(routeAccountId))
    : userAuthentication;

  authPromise.then(() => {
    const { isLoggedIn } = store.getters;

    if (!isLoggedIn) return next();

    if (!routeAccountId) return next();

    const isOnboarding = store.getters['wgptOnboarding/isPending'];

    if (isOnboarding) {
      if (to.name?.startsWith('wgpt_onboarding')) return next();
      return next({
        name: 'wgpt_onboarding',
        params: { accountId: routeAccountId },
      });
    }

    if (to.name?.startsWith('wgpt_onboarding')) {
      return next(frontendURL(`accounts/${routeAccountId}/dashboard`));
    }

    return next();
  });
};

export default onboardingGuard;
